// Clarity is injected imperatively rather than through a <Helmet> snippet like the other vendors.
// react-helmet 5.2.1 registers its DOM side effect in componentWillMount (via react-side-effect),
// which React 19 no longer honours, so script tags rendered through <Helmet> are not reliably
// added to the head. Woopra and Amplitude already init this way and load reliably. See OWA-11690.

const CLARITY_TAG_URL = 'https://www.clarity.ms/tag/';

type TClarity = { (...args: unknown[]): void; q?: unknown[][] };

// stands in for the real library until the tag arrives, queueing anything called in the meantime;
// the library drains `q` once it loads
const createQueueStub = (): TClarity => {
  const stub: TClarity = (...args: unknown[]) => {
    stub.q = stub.q || [];
    stub.q.push(args);
  };
  return stub;
};

export const initClarity = (projectId: string, sessionUuid: string, currentUserUuid?: string) => {
  if (typeof window === 'undefined' || !projectId) {
    return;
  }

  let clarity = window.clarity;

  // the effect this runs from re-fires whenever the user or the dynamic parameters change, so the
  // tag itself is only ever injected once - the identify call below is safe to repeat
  if (!clarity) {
    clarity = createQueueStub();
    window.clarity = clarity;

    const tag = document.createElement('script');
    tag.async = true;
    tag.src = `${CLARITY_TAG_URL}${projectId}`;
    document.head.appendChild(tag);
  }

  // identify(custom-id, custom-session-id) mirrors the Hotjar identify call, so recordings from
  // both vendors can be cross-referenced while they run in parallel
  clarity('identify', currentUserUuid || sessionUuid, sessionUuid);
  clarity('set', 'sessionUuid', sessionUuid);
};
